import { render, staticRenderFns } from "./recommend-rent-house.vue?vue&type=template&id=91e07898&scoped=true&"
import script from "./recommend-rent-house.vue?vue&type=script&lang=js&"
export * from "./recommend-rent-house.vue?vue&type=script&lang=js&"
import style0 from "./recommend-rent-house.vue?vue&type=style&index=0&id=91e07898&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e07898",
  null
  
)

export default component.exports